import { SearchModule } from "./SearchModule";

export const searchModules: SearchModule[] = [];
